import { graphql } from '@/graphql-setup'

/**
 * Create AbsenceComment
 */
export const CREATE_ABSENCE_COMMENTS_MUTATION = graphql(`
  mutation CreateAbsenceComment($input: CreateAbsenceCommentInput!) {
    createAbsenceComment(input: $input) {
      absenceComment {
        id
      }
    }
  }
`)

/**
 * Update AbsenceComment
 */
export const UPDATE_ABSENCE_COMMENTS_MUTATION = graphql(`
  mutation UpdateAbsenceComment($id: ID!, $input: UpdateAbsenceCommentInput!) {
    updateAbsenceComment(id: $id, input: $input) {
      absenceComment {
        id
      }
    }
  }
`)

/**
 * Delete AbsenceComment
 */
export const DELETE_ABSENCE_COMMENTS_MUTATION = graphql(`
  mutation DeleteAbsenceComment($id: ID!) {
    deleteAbsenceComment(id: $id) {
      found
    }
  }
`)
